import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import TextInput from "../../../Components/TextInput";
import { Ripple } from "primereact/ripple";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Toast } from 'primereact/toast';
import { Dropdown, DropdownChangeEvent } from 'primereact/dropdown';
import { confirmDialog } from 'primereact/confirmdialog';
import { Checkbox } from "primereact/checkbox";
import { checkEmail, checkPhoneNumber, checkText } from "../../../Utils/Validator";
import { contactCreateAPI, createCommercialClientComanyAPI, createDomesticClientProjectAPI, employeePersonalDataAPI, employeeRoleDataAPI, roleDataGetAPI } from "../../../Api/ContactApi";
import { ClientProject } from "../../../Controllers/Types/ClientProjectInterface";
import { Dialog } from "primereact/dialog";
import { mapRoles, Role } from "../../../Controllers/Types/UserRoleInterface";
import { useAppDispatch, useAppSelector } from "../../../Controllers/hooks";
import { addComClientProject, clearComClientProject, setCurrentClientContactId, setCurrentComClientTab, setCurrentDomClientTab } from "../../../Controllers/Slices/contactSlice";
import { goToTop } from "../../../Components/goToTop";
import EmailSearchDialog from "../EmailSearchDialog";
import { useSelector } from "react-redux";
import { RootState } from "../../../Controllers/Store";
import { hasPermission } from "../../../Controllers/Selectors/permissionsSelector";
import DataListModalInput from "../../../Components/DataListModal/DataListModalInput";
import RoleSelectionModal from "../../../Components/RoleSelectionModal";

interface EmployeeType {
    employee_type: string;
}

const employee_types: EmployeeType[] = [
    {
        employee_type: "Commercial client"
    },
    {
        employee_type: "Domestic client"
    }
];

interface ModelContentProps {
    title: string;
    data: string;
}

const AddClientContact: React.FC = () => {
    const contactId = useAppSelector(state => state.contact.clientContactId);
    const commercialClientPage = useAppSelector(state => state.contact.currentComClientTab);
    const domesticClientPage = useAppSelector(state => state.contact.currentDomClientTab);
    const projectList = useAppSelector(state => state.contact.comClientProjectList);
    const dispatch = useAppDispatch()

    //const [commercialClientPage, setCommercialClientPage] = useState<string>('Personal');
    //const [domesticClientPage, setDomesticClientPage] = useState<string>('Personal');
    const toast = useRef<Toast>(null);
    const navigate = useNavigate();
    const location = useLocation();

    const [showError, setShowError] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [showAlert, setShowAlert] = useState<boolean>(false);
    const [successMessage, setSuccessMessage] = useState<string>('');
    const [showAddData, setShowAddData] = useState<boolean>(false);

    const [showProjectDetailModal, setShowProjectDetailModal] = useState<boolean>(false);
    const [selectProject, setSelectProject] = useState<ClientProject | null>(null);

    /* Personal form variables */
    const [personalProfileImage, setPersonalProfileImage] = useState<string | null>(null);
    const [personalProfileImageFile, setPersonalProfileImageFile] = useState<File | null>(null);
    const [firstName, setFirstName] = useState<string>('');
    const [lastName, setLastName] = useState<string>('');
    const [email, setEmail] = useState<string>('');
    const [mobile, setMobile] = useState<string>('');
    const [landline, setLandline] = useState<string>('');
    const [address, setAddress] = useState<string>('');
    const [city, setCity] = useState<string>('');
    const [postCode, setPostCode] = useState<string>('');

    /* Project form variables */
    const [projectName, setProjectName] = useState<string>('');
    const [projectAddress, setProjectAddress] = useState<string>('');
    const [projectCity, setProjectCity] = useState<string>('');
    const [projectPostCode, setProjectPostCode] = useState<string>('');

    const [companyName, setCompanyName] = useState<string>('');
    const [companyRegNo, setCompanyRegNo] = useState<string>('');
    const [companyEmail, setCompanyEmail] = useState<string>('');
    const [companyMobile, setCompanyMobile] = useState<string>('');
    const [companyLandline, setCompanyLandline] = useState<string>('');
    const [companyAddress, setCompanyAddress] = useState<string>('');
    const [companyCity, setCompanyCity] = useState<string>('');
    const [companyPostCode, setCompanyPostCode] = useState<string>('');

    const [dataState, setDataState] = useState<string>('Create');


    const [roleList, setRoleList] = useState<Role[]>([]);
    const [selectedRole, setSelectedRole] = useState<Role | null>(null);


    const [addRoleName, setAddRoleName] = useState<string>('');
    const [displayRoleName, setDisplayRoleName] = useState<string>('');

    const [addRoleNameError, setAddRoleNameError] = useState<string>('');

    const [selectedRoleError, setSelectedRoleError] = useState<string>('');
    const [displayRoleNameError, setDisplayRoleNameError] = useState<string>('');
    const [displayRoleCommonError, setDisplayRoleCommonError] = useState<string>('');


    /* Personal error massage */
    const [errorFirstName, setErrorFirstName] = useState<string>('');
    const [errorLastName, setErrorLastName] = useState<string>('');
    const [errorEmail, setErrorEmail] = useState<string>('');
    const [errorMoblile, setErrorMoblile] = useState<string>('');
    const [errorLandline, setErrorLandline] = useState<string>('');
    const [errorAddress, setErrorAddress] = useState<string>('');
    const [errorCity, setErrorCity] = useState<string>('');
    const [errorPostCode, setErrorPostCode] = useState<string>('');

    const [errorProjectName, setErrorProjectName] = useState<string>('');
    const [errorProjectAddress, setErrorProjectAddress] = useState<string>('');
    const [errorProjectCity, setErrorProjectCity] = useState<string>('');
    const [errorProjectPostCode, setErrorProjectPostCode] = useState<string>('');
    const [errorCompanyName, setErrorCompanyName] = useState<string>('');
    const [errorCompanyRegNo, setErrorCompanyRegNo] = useState<string>('');
    const [errorCompanyEmail, setErrorCompanyEmail] = useState<string>('');
    const [errorCompanyMobile, setErrorCompanyMobile] = useState<string>('');
    const [errorCompanyLandline, setErrorCompanyLandline] = useState<string>('');
    const [errorCompanyAddress, setErrorCompanyAddress] = useState<string>('');
    const [errorCompanyCity, setErrorCompanyCity] = useState<string>('');
    const [errorCompanyPostCode, setErrorCompanyPostCode] = useState<string>('');

    //const [contactId, setContactId] = useState<number | undefined>(0);


    /******************************** DOMESTIC CLIENT *******************************************************/
    const [checkedProjectState, setCheckedProjectState] = useState<boolean>(false);

    /* Personal form variables */

    const [firstNameDomCli, setFirstNameDomCli] = useState<string>('');
    const [lastNameDomCli, setLastNameDomCli] = useState<string>('');
    const [emailDomCli, setEmailDomCli] = useState<string>('');
    const [mobileDomCli, setMobileDomCli] = useState<string>('');
    const [landlineDomCli, setLandlineDomCli] = useState<string>('');
    const [addressDomCli, setAddressDomCli] = useState<string>('');
    const [cityDomCli, setCityDomCli] = useState<string>('');
    const [postCodeDomCli, setPostCodeDomCli] = useState<string>('');

    const [personalProfileImageFileDomCli, setPersonalProfileImageFileDomCli] = useState<File | null>(null);

    /* Personal Error form variables */

    const [firstNameDomCliError, setFirstNameDomCliError] = useState<string>('');
    const [lastNameDomCliError, setLastNameDomCliError] = useState<string>('');
    const [emailDomCliError, setEmailDomCliError] = useState<string>('');
    const [mobileDomCliError, setMobileDomCliError] = useState<string>('');
    const [landlineDomCliError, setLandlineDomCliError] = useState<string>('');
    const [addressDomCliError, setAddressDomCliError] = useState<string>('');
    const [cityDomCliError, setCityDomCliError] = useState<string>('');
    const [postCodeDomCliError, setPostCodeDomCliError] = useState<string>('');

    /* Project form variables */
    const [projectAddressDomCli, setProjectAddressDomCli] = useState<string>('');
    const [projectCityDomCli, setProjectCityDomCli] = useState<string>('');
    const [projectPostCodeDomCli, setProjectPostCodeDomCli] = useState<string>('');


    /* Project form error variables */
    const [projectAddressDomCliError, setProjectAddressDomCliError] = useState<string>('');
    const [projectCityDomCliError, setProjectCityDomCliError] = useState<string>('');
    const [projectPostCodeDomCliError, setProjectPostCodeDomCliError] = useState<string>('');

    /* DOM CLIENT ROLE VARIABLE */
    const [addRoleNameDomCli, setAddRoleNameDomCli] = useState<string>('');
    const [addRoleNameErrorDomCli, setAddRoleNameErrorDomCli] = useState<string>('');

    const [selectedRoleErrorDomCli, setSelectedRoleDomCliError] = useState<string>('');
    const [displayRoleNameDomCli, setDisplayRoleNameDomCli] = useState<string>('');
    const [displayRoleNameErrorDomCli, setDisplayRoleNameDomCliError] = useState<string>('');

    const [displayRoleCommonErrorDomCli, setDisplayRoleCommonDomCliError] = useState<string>('');

    const [showSearchComClientEmailModal, setShowSearchComClientEmailModal] = useState<boolean>(false);
    const [showSearchDomClientEmailModal, setShowSearchDomClientEmailModal] = useState<boolean>(false);

    /* For permission */
    const useCanEdit = (screen: string, permission: string) => {
        return useSelector((state: RootState) => hasPermission(state, screen, permission));
    };

    const isPermissionEmployee = useCanEdit('Contact', 'Employee');
    const isPermissionProfessional = useCanEdit('Contact', 'Professional');
    const isPermissionClient = useCanEdit('Contact', 'Client');


    // this is from dinesh dooing 
    // const formRef = useRef<HTMLDivElement | null>(null);
    // const [isDirty, setIsDirty] = useState(false);

    // useEffect(() => {
    //     const handleClickOutside = (event: MouseEvent) => {
    //         if (formRef.current && !formRef.current.contains(event.target as Node)) {
    //             if (isDirty) {
    //                 alert("You have unsaved changes!");
    //             }
    //         }
    //     };

    //     document.addEventListener("mousedown", handleClickOutside);
    //     return () => {
    //         document.removeEventListener("mousedown", handleClickOutside);
    //     };
    // }, [isDirty]);


    const handleDomCliProjectAddressSameCheckBoxOnChange = (isChecked: boolean) => {
        setCheckedProjectState(isChecked);
        if (isChecked) {
            setProjectAddressDomCli(addressDomCli)
            setProjectCityDomCli(cityDomCli)
            setProjectPostCodeDomCli(postCodeDomCli)
        } else {
            setProjectAddressDomCli('')
            setProjectCityDomCli('')
            setProjectPostCodeDomCli('')
        }
    }


    /************************* API REQUEST ************************************************/


    function showAPIErrorPersonalData(keyName: string, error: string): void {

        if (keyName === "email") {
            setShowError(true);
            setErrorEmail(error);
        }
        if (keyName === "mobile") {
            setShowError(true);
            setErrorMoblile(error);
        }
        if (keyName === "landline") {
            setShowError(true);
            setErrorLandline(error);
        }
    }

    function showAPIErrorCompanyData(keyName: string, error: string): void {

        if (keyName === "company_email") {
            setErrorCompanyEmail(error);
        }
        if (keyName === "company_phone") {
            setErrorCompanyMobile(error);
        }
        if (keyName === "company_regno") {
            setErrorCompanyRegNo(error);
        }
    }

    const contactCreate = async () => {
        const data = await contactCreateAPI("Client", "Commercial Client", localStorage.getItem('token') || '');

        if (data.status) {
            //setContactId(data.contactId);
            dispatch(setCurrentClientContactId(data.contactId!));
        }

        return data.contactId;
    }

    const contactCreateDomCli = async () => {
        const data = await contactCreateAPI("Client", "Domestic Client", localStorage.getItem('token') || '');

        if (data.status) {
            //setContactId(data.contactId);
            dispatch(setCurrentClientContactId(data.contactId!));
        }

        return data.contactId;
    }

    const saveEmployeePersonalData = async (createdContactId: number) => {
        const data = await employeePersonalDataAPI(createdContactId, firstName, lastName, email, mobile, landline, address, city, postCode, personalProfileImageFile!, localStorage.getItem('token') || '', null, '');
        setLoading(false);

        if (!data.status) { // false
            if (data.statusCode === 422) {
                Object.entries(data.errors ?? []).map(([key, value], index) => (
                    showAPIErrorPersonalData(key, value[0])
                ))
            }
        } else {

            if (toast.current) {
                toast.current.show({
                    severity: 'success',
                    summary: 'Success',
                    detail: 'Personal data created successfully.',
                    life: 3000
                });
            }

            setLoading(false);
            setShowError(false);
            dispatch(setCurrentComClientTab('Project'));
            //setCommercialClientPage('Project');
            goToTop();
        }
    }


    /******************************** For employee type  ********************************/
    const [employeeType, setEmployeeType] = useState<EmployeeType>(employee_types[0]);

    const handleEmployeeTypeChange = (e: DropdownChangeEvent) => {
        confirmDialog({
            message: 'Are you sure you want to change the employee type? The fields you entered will be cleared.',
            header: 'Alert',
            icon: 'bi bi-info-circle',
            defaultFocus: 'accept',
            acceptClassName: 'p-button-danger',
            accept: () => setEmployeeType(e.value),
            dismissableMask: true,
            draggable: false,
            resizable: false,
        });
    };

    useEffect(() => {
        if (location?.state && location?.state?.contactFor) {
            const contactAddFor = location?.state?.contactFor

            if (contactAddFor === 'Commercial client') {
                setEmployeeType(employee_types[0]);
            } else {
                setEmployeeType(employee_types[1]);
            }
        } else {
            setEmployeeType(employee_types[0]);
        }
    }, [location?.state]);

    /***************************************************************************************/


    /******************************** For commercial client  ********************************/
    function checkCredentials(): boolean {
        const isEmailValid = checkEmail(email, true, setErrorEmail);
        const isFirstNameValid = checkText(firstName, true, setErrorFirstName);
        const isLastNameValid = checkText(lastName, true, setErrorLastName);
        const isMobileValid = checkPhoneNumber(mobile, false, setErrorMoblile);
        const isLandlineNumberValid = checkPhoneNumber(landline, false, setErrorLandline);
        const isAddressValid = checkText(address, true, setErrorAddress);
        const isCityValid = checkText(city, true, setErrorCity);
        const isPostCodeValid = checkText(postCode, true, setErrorPostCode);

        return isEmailValid && isFirstNameValid && isLastNameValid && isMobileValid && isLandlineNumberValid && isAddressValid && isCityValid && isPostCodeValid;
    }

    function checkCredentialsProject(): boolean {
        const isProjectNameValid = checkText(projectName, true, setErrorProjectName);
        const isProjectAddressValid = checkText(projectAddress, true, setErrorProjectAddress);
        const isProjectCityValid = checkText(projectCity, true, setErrorProjectCity);
        const isProjectPostCodeValid = checkText(projectPostCode, true, setErrorProjectPostCode);

        const isCompanyNameValid = checkText(companyName, false, setErrorCompanyName);
        const isCompanyRegNoValid = checkText(companyRegNo, false, setErrorCompanyRegNo);
        const isCompanyEmailValid = checkEmail(companyEmail, false, setErrorCompanyEmail);
        const isCompanyMobileValid = checkPhoneNumber(companyMobile, false, setErrorCompanyMobile);
        const isCompanyLandlineValid = checkPhoneNumber(companyLandline, false, setErrorCompanyLandline);
        const isCompanyAddressValid = checkText(companyAddress, false, setErrorCompanyAddress);
        const isCompanyCityValid = checkText(companyCity, false, setErrorCompanyCity);
        const isCompanyPostCodeValid = checkText(companyPostCode, false, setErrorCompanyPostCode);

        return isProjectNameValid && isProjectAddressValid && isProjectCityValid && isProjectPostCodeValid && isCompanyNameValid && isCompanyRegNoValid && isCompanyEmailValid
            && isCompanyMobileValid && isCompanyLandlineValid && isCompanyAddressValid && isCompanyCityValid && isCompanyPostCodeValid;
    }

    // for save commercial client personal details
    const handleSaveComClientPersonalDetails = async (e: React.FormEvent) => {
        e.preventDefault();

        if (checkCredentials()) {

            setLoading(true);
            if (contactId === 0) {

                const createdContactId = await contactCreate();

                saveEmployeePersonalData(createdContactId!);
            } else {
                saveEmployeePersonalData(contactId!);
            }
        }
    }

    // for save commercial client Project details
    const handleSaveComClientProjectDetails = async (e: React.FormEvent) => {
        e.preventDefault();

        if (projectList.length === 0) {
            if (checkCredentialsProject()) {
                setLoading(true);
                const data = await createCommercialClientComanyAPI(contactId!, projectName, projectAddress, projectCity, projectPostCode,
                    companyName, companyRegNo, companyEmail, companyMobile, companyAddress,
                    companyCity, companyPostCode);

                setLoading(false);

                if (!data.status) { // false
                    if (data.statusCode === 422) {
                        Object.entries(data.errors ?? []).map(([key, value], index) => (
                            showAPIErrorCompanyData(key, value[0])
                        ))
                    }
                } else {

                    if (toast.current) {
                        toast.current.show({
                            severity: 'success',
                            summary: 'Success',
                            detail: 'The Project for the commercial client was added successfully.',
                            life: 3000
                        });
                    }

                    setLoading(false);
                    setShowError(false);
                    dispatch(setCurrentComClientTab('Role'));
                    //setCommercialClientPage('Role');
                    goToTop();
                }
            }
        } else {
            dispatch(clearComClientProject())
            dispatch(setCurrentComClientTab('Role'));
            //setCommercialClientPage('Role');
            goToTop();
        }
    }

    function checkCredentialsRole(): boolean {

        let isSelectedRoleValid: boolean = false

        if (selectedRole !== null && selectedRole !== undefined) {
            isSelectedRoleValid = true;
            setSelectedRoleError('')
        } else {
            setSelectedRoleError('This field is required.')
        }

        const isDisplayRoleNameValid = checkText(displayRoleName, true, setDisplayRoleNameError)


        return isSelectedRoleValid && isDisplayRoleNameValid;
    }

    // for save commercial client Role details
    const handleSaveComClientRoleDetails = async (e: React.FormEvent) => {
        e.preventDefault();

        if (checkCredentialsRole()) {
            setLoading(true);
            const res = await employeeRoleDataAPI(contactId!, selectedRole?.id!, displayRoleName, localStorage.getItem('token') || '');
            setLoading(false);

            if (res.status) {
                if (toast.current) {
                    toast.current.show({
                        severity: 'success',
                        summary: 'Success',
                        detail: 'Role info created successfully.',
                        life: 3000
                    });
                }

                dispatch(setCurrentClientContactId(0))
                dispatch(clearComClientProject())
                dispatch(setCurrentComClientTab('Personal'))

                setShowAlert(true);
                setSuccessMessage('Commercial client details added successfully.');
                setTimeout(() => {
                    setShowAlert(false);
                    handleNavigateContact();
                }, 2000);

            } else {
                if (res.statusCode === 422) {
                    Object.entries(res.errors ?? []).map(([key, value], index) => (
                        setDisplayRoleCommonError(value[0])
                    ))
                }
            }
        }
    }

    // For add more project
    const handleAddProject = async (e: React.FormEvent) => {
        e.preventDefault();

        if (checkCredentialsProject()) {
            setLoading(true);
            const data = await createCommercialClientComanyAPI(contactId!, projectName, projectAddress, projectCity, projectPostCode,
                companyName, companyRegNo, companyEmail, companyMobile, companyAddress,
                companyCity, companyPostCode);

            setLoading(false);

            if (!data.status) { // false
                if (data.statusCode === 422) {
                    Object.entries(data.errors ?? []).map(([key, value], index) => (
                        showAPIErrorCompanyData(key, value[0])
                    ))
                }
            } else {

                if (toast.current) {
                    toast.current.show({
                        severity: 'success',
                        summary: 'Success',
                        detail: 'Project added successfully',
                        life: 3000
                    });
                }

                const clientProject: ClientProject = {
                    id: 0, contactId: 0,
                    projectName: projectName, projectAddress: projectAddress, projectCity: projectCity, projectPostCode: projectPostCode,
                    companyName: companyName, companyRegNo: companyRegNo, email: companyEmail, mobile: companyMobile,
                    landline: '', address: companyAddress, city: companyCity, postCode: companyPostCode
                };

                addProject(clientProject);
                clearProjectDetails();
                goToTop();

            }

        }


    };

    const addProject = (project: ClientProject) => {
        //projectList.push(project)
        dispatch(addComClientProject(project))

    }

    const clearProjectDetails = () => {
        setProjectName('')
        setProjectAddress('')
        setProjectCity('')
        setProjectPostCode('')

        setCompanyName('')
        setCompanyRegNo('')
        setCompanyEmail('')
        setCompanyMobile('')
        setCompanyLandline('')
        setCompanyAddress('')
        setCompanyCity('')
        setCompanyPostCode('')



    }

    // For select added project
    const handleSelectProject = async (e: React.FormEvent, project: ClientProject) => {
        e.preventDefault();

        setSelectProject(project);
        setShowProjectDetailModal(true);

    }
    /***************************************************************************************/
    function checkCredentialsDomCli(): boolean {

        const isFirstNameValid = checkText(firstNameDomCli, true, setFirstNameDomCliError);
        const isLastNameValid = checkText(lastNameDomCli, true, setLastNameDomCliError);
        const isEmailValid = checkEmail(emailDomCli, true, setEmailDomCliError);
        const isMobileValid = checkPhoneNumber(mobileDomCli, false, setMobileDomCliError);
        const isLandlineNumberValid = checkPhoneNumber(landlineDomCli, false, setLandlineDomCliError);
        const isAddressValid = checkText(addressDomCli, true, setAddressDomCliError);
        const isCityValid = checkText(cityDomCli, true, setCityDomCliError);
        const isPostCodeValid = checkText(postCodeDomCli, true, setPostCodeDomCliError);

        return isEmailValid && isFirstNameValid && isLastNameValid && isMobileValid && isLandlineNumberValid && isAddressValid && isCityValid && isPostCodeValid;
    }

    function showAPIErrorPersonalDataDomClient(keyName: string, error: string): void {

        if (keyName === "email") {
            setShowError(true);
            setEmailDomCliError(error);
        }
        if (keyName === "mobile") {
            setShowError(true);
            setMobileDomCliError(error);
        }
        if (keyName === "landline") {
            setShowError(true);
            setLandlineDomCliError(error);
        }
    }

    function checkCredentialsProjectDomCli(): boolean {
        const isProjectAddressValid = checkText(projectAddressDomCli, true, setProjectAddressDomCliError);
        const isProjectCityValid = checkText(projectCityDomCli, true, setProjectCityDomCliError);
        const isProjectPostCodeValid = checkText(projectPostCodeDomCli, true, setProjectPostCodeDomCliError);

        return isProjectAddressValid && isProjectCityValid && isProjectPostCodeValid;
    }

    function showAPIErrorDomCLiProject(keyName: string, error: string): void {

        if (keyName === "address") {
            setProjectAddressDomCliError(error);
        }
        if (keyName === "city") {
            setProjectCityDomCliError(error);
        }
        if (keyName === "post_code") {
            setProjectPostCodeDomCliError(error);
        }
    }

    const saveDomClientPersonalData = async (createdContactId: number) => {
        const data = await employeePersonalDataAPI(createdContactId, firstNameDomCli, lastNameDomCli, emailDomCli, mobileDomCli, landlineDomCli, addressDomCli, cityDomCli, postCodeDomCli, personalProfileImageFileDomCli!, localStorage.getItem('token') || '', null, '');
        setLoading(false);

        if (!data.status) { // false
            if (data.statusCode === 422) {
                Object.entries(data.errors ?? []).map(([key, value], index) => (
                    showAPIErrorPersonalDataDomClient(key, value[0])
                ))
            }
        } else {

            if (toast.current) {
                toast.current.show({
                    severity: 'success',
                    summary: 'Success',
                    detail: 'Personal data created successfully.',
                    life: 3000
                });
            }

            dispatch(setCurrentDomClientTab('Project'));
            goToTop();

        }
    }


    /******************************** For domestic client  ********************************/
    function checkCredentialsRoleDomCli(): boolean {

        let isSelectedRoleValid: boolean = false

        if (selectedRole !== null && selectedRole !== undefined) {
            isSelectedRoleValid = true;
            setSelectedRoleDomCliError('')
        } else {
            isSelectedRoleValid = false;
            setSelectedRoleDomCliError('This field is required.')
        }

        const isDisplayRoleNameValid = checkText(displayRoleNameDomCli, true, setDisplayRoleNameDomCliError)


        return isSelectedRoleValid && isDisplayRoleNameValid;
    }

    // For Save Domestic Client Personal Details
    const handleSaveDomClientPersonalDetails = async (e: React.FormEvent) => {
        e.preventDefault();

        if (checkCredentialsDomCli()) {

            setLoading(true);
            if (contactId === 0) {

                const createdContactId = await contactCreateDomCli();

                saveDomClientPersonalData(createdContactId!);
            } else {
                saveDomClientPersonalData(contactId!);
            }

        }


    }

    // For Save Domestic Client Project Details
    const handleSaveDomClientProjectDetails = async (e: React.FormEvent) => {
        e.preventDefault();

        if (checkCredentialsProjectDomCli()) {


            setLoading(true);

            const data = await createDomesticClientProjectAPI(contactId!, projectAddressDomCli, projectCityDomCli, projectPostCodeDomCli);

            setLoading(false);

            if (!data.status) { // false
                if (data.statusCode === 422) {
                    Object.entries(data.errors ?? []).map(([key, value], index) => (
                        showAPIErrorDomCLiProject(key, value[0])
                    ))
                }
            } else {

                if (toast.current) {
                    toast.current.show({
                        severity: 'success',
                        summary: 'Success',
                        detail: 'The Project for the domestic client was added successfully.',
                        life: 3000
                    });
                }

                dispatch(setCurrentDomClientTab('Role'));
                goToTop();

            }

        }


    }

    // For Save Role Details
    const handleSaveDomClientRoleDetails = async (e: React.FormEvent) => {
        e.preventDefault();

        if (checkCredentialsRoleDomCli()) {
            setLoading(true);
            const res = await employeeRoleDataAPI(contactId!, selectedRole?.id!, displayRoleNameDomCli, localStorage.getItem('token') || '');
            setLoading(false);

            if (res.status) {
                if (toast.current) {
                    toast.current.show({
                        severity: 'success',
                        summary: 'Success',
                        detail: 'Role info created successfully.',
                        life: 3000
                    });
                }

                dispatch(setCurrentClientContactId(0))
                dispatch(setCurrentDomClientTab('Personal'))

                setShowAlert(true);
                setSuccessMessage('Domestic client details added successfully.');
                setTimeout(() => {
                    setShowAlert(false);
                    handleNavigateContact();
                }, 2000);

            } else {
                if (res.statusCode === 422) {
                    Object.entries(res.errors ?? []).map(([key, value], index) => (
                        setDisplayRoleCommonDomCliError(value[0])
                    ))
                }
            }

        }

    }
    /***************************************************************************************/


    /******************************** For role  ********************************/
    function checkCredentialsRoleCreate(roleName: string): boolean {
        const isRoleNameValid = checkText(roleName, true, setAddRoleNameError);

        return isRoleNameValid;
    }

    const roleDataGet = async () => {
        const data = await roleDataGetAPI(localStorage.getItem('token') || '');
        if (data.status) {
            setRoleList(mapRoles(data.data || []) || []);
        }
    }


    /*********************************** For image upload ***********************************/
    const handlePersonalProfileImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files[0]) {
            const reader = new FileReader();
            reader.onload = (event: ProgressEvent<FileReader>) => {
                if (event.target && typeof event.target.result === 'string') {
                    setPersonalProfileImage(event.target.result);
                }
            };
            reader.readAsDataURL(e.target.files[0]);
        }
    };

    // For clear image
    const clearPersonalProfileImage = () => {
        setPersonalProfileImage(null);
    };


    /********************** DOM CLIENT ROLE ***********************/
    function checkCredentialsRoleCreateDomCli(): boolean {
        const isRoleNameValid = checkText(addRoleNameDomCli, true, setAddRoleNameErrorDomCli);

        return isRoleNameValid;
    }




    const [minHeight, setMinHeight] = useState<string>('0px');

    const calculateMinHeight = () => {
        const windowHeight = window.innerHeight;
        const distanceFromBottom = 200;
        const calculatedHeight = windowHeight - distanceFromBottom;
        setMinHeight(`${calculatedHeight}px`);
    };

    const goBack = () => {
        navigate(-1);
        goToTop();
    };

    const handleCloseAlert = () => {
        setShowAlert(false);
    };

    const toggleAddData = () => {
        setShowAddData(!showAddData);
    };

    /* Project details */
    const handleCloseProjectDetailModal = () => {
        setShowProjectDetailModal(false);
        setSelectProject(null);
    }

    const projectDetailModalHeader = (
        <div className="custom_modal_header_inner">
            <h5 className="modal-title fs-5">
                Project details
            </h5>

            <button type="button" className="close_modal_btn p-ripple"
                onClick={handleCloseProjectDetailModal}>
                <i className="bi bi-x-circle"></i>
                <Ripple />
            </button>
        </div>
    );

    const projectDetailModalFooter = (
        <div className="custom_modal_footer">
            <Button label="Close" className="custom_btn secondary" onClick={handleCloseProjectDetailModal} />
        </div>
    );

    const ModelContent: React.FC<ModelContentProps> = ({ title, data }) => {
        return (
            <div className="col-12 col-xl-4 col-sm-6">
                <div className="page_form_group">
                    <label className="custom_form_label">{title}</label>
                    <div className="form_data_view_box">
                        <p>{data}</p>
                    </div>
                </div>
            </div>
        );
    };

    useEffect(() => {
        calculateMinHeight();
        window.addEventListener('resize', calculateMinHeight);

        return () => {
            window.removeEventListener('resize', calculateMinHeight);
        };
    }, []);

    useEffect(() => {
        dispatch(setCurrentClientContactId(0));
        dispatch(setCurrentComClientTab('Personal'));
        dispatch(clearComClientProject());

        dispatch(setCurrentDomClientTab('Personal'));

        roleDataGet();
    }, []);

    const handleNavigateAddContact = (type: 'employee' | 'professional' | 'client') => {
        const currentPage = 'client';

        if (currentPage !== type) {
            confirmDialog({
                message: `Are you sure you want to switch to ${type}? The fields you entered will be cleared.`,
                header: 'Alert',
                icon: 'bi bi-info-circle',
                defaultFocus: 'accept',
                acceptClassName: 'p-button-danger',
                accept: () => {
                    if (type === 'employee') {
                        navigate(`/contact/employee/add`);
                    } else if (type === 'professional') {
                        navigate(`/contact/professional/add`);
                    } else {
                        return
                    }
                },
                dismissableMask: true,
                draggable: false,
                resizable: false,
            });
        } else {
            return;
        }
        goToTop();
    }


    const handleNavigateContact = () => {
        goToTop();
        navigate(`/contact`)
    }

    const onEmailConfirmComClient = (email: string) => {
        setEmail(email);
        setShowSearchComClientEmailModal(false);
    }

    const onEmailConfirmDomClient = (email: string) => {
        setEmailDomCli(email);
        setShowSearchDomClientEmailModal(false);
    }


    /* Clear validation messages */
    // For Commercial client
    // Personal
    useEffect(() => {
        checkEmail(email, false, setErrorEmail);
    }, [email]);

    useEffect(() => {
        checkText(firstName, false, setErrorFirstName);
    }, [firstName]);

    useEffect(() => {
        checkText(lastName, false, setErrorLastName);
    }, [lastName]);

    useEffect(() => {
        checkPhoneNumber(mobile, false, setErrorMoblile);
    }, [mobile]);

    useEffect(() => {
        checkPhoneNumber(landline, false, setErrorLandline);
    }, [landline]);

    useEffect(() => {
        checkText(address, false, setErrorAddress);
    }, [address]);

    useEffect(() => {
        checkText(city, false, setErrorCity);
    }, [city]);

    useEffect(() => {
        checkText(postCode, false, setErrorPostCode);
    }, [postCode]);
    // 

    // Project
    useEffect(() => {
        checkText(projectName, false, setErrorProjectName);
    }, [projectName]);

    useEffect(() => {
        checkText(projectAddress, false, setErrorProjectAddress);
    }, [projectAddress]);

    useEffect(() => {
        checkText(projectCity, false, setErrorProjectCity);
    }, [projectCity]);

    useEffect(() => {
        checkText(projectPostCode, false, setErrorProjectPostCode);
    }, [projectPostCode]);

    useEffect(() => {
        checkText(companyName, false, setErrorCompanyName);
    }, [companyName]);

    useEffect(() => {
        checkText(companyRegNo, false, setErrorCompanyRegNo);
    }, [companyRegNo]);

    useEffect(() => {
        checkEmail(companyEmail, false, setErrorCompanyEmail);
    }, [companyEmail]);

    useEffect(() => {
        checkPhoneNumber(companyMobile, false, setErrorCompanyMobile);
    }, [companyMobile]);

    useEffect(() => {
        checkPhoneNumber(companyLandline, false, setErrorCompanyLandline);
    }, [companyLandline]);

    useEffect(() => {
        checkText(companyAddress, false, setErrorCompanyAddress);
    }, [companyAddress]);

    useEffect(() => {
        checkText(companyCity, false, setErrorCompanyCity);
    }, [companyCity]);

    useEffect(() => {
        checkText(companyPostCode, false, setErrorCompanyPostCode);
    }, [companyPostCode]);
    // 

    // Role
    useEffect(() => {
        if (selectedRole !== null && selectedRole !== undefined) {
            setSelectedRoleError('');
        }
    }, [selectedRole]);

    useEffect(() => {
        checkText(displayRoleName, false, setDisplayRoleNameError);
    }, [displayRoleName]);

    useEffect(() => {
        checkText(addRoleName, false, setAddRoleNameError);
    }, [addRoleName]);
    //
    /*  */

    // For Domestic client
    // Personal
    useEffect(() => {
        checkText(firstNameDomCli, false, setFirstNameDomCliError);
    }, [firstNameDomCli]);

    useEffect(() => {
        checkText(lastNameDomCli, false, setLastNameDomCliError);
    }, [lastNameDomCli]);

    useEffect(() => {
        checkEmail(emailDomCli, false, setEmailDomCliError);
    }, [emailDomCli]);

    useEffect(() => {
        checkPhoneNumber(mobileDomCli, false, setMobileDomCliError);
    }, [mobileDomCli]);

    useEffect(() => {
        checkPhoneNumber(landlineDomCli, false, setLandlineDomCliError);
    }, [landlineDomCli]);

    useEffect(() => {
        checkText(addressDomCli, false, setAddressDomCliError);
    }, [addressDomCli]);

    useEffect(() => {
        checkText(cityDomCli, false, setCityDomCliError);
    }, [cityDomCli]);

    useEffect(() => {
        checkText(postCodeDomCli, false, setPostCodeDomCliError);
    }, [postCodeDomCli]);
    // 

    // Project
    useEffect(() => {
        checkText(projectAddressDomCli, false, setProjectAddressDomCliError);
    }, [projectAddressDomCli]);

    useEffect(() => {
        checkText(projectCityDomCli, false, setProjectCityDomCliError);
    }, [projectCityDomCli]);

    useEffect(() => {
        checkText(projectPostCodeDomCli, false, setProjectPostCodeDomCliError);
    }, [projectPostCodeDomCli]);

    // Role
    useEffect(() => {
        if (selectedRole !== null && selectedRole !== undefined) {
            setSelectedRoleDomCliError('');
        }
    }, [selectedRole]);

    useEffect(() => {
        checkText(displayRoleNameDomCli, false, setDisplayRoleNameDomCliError);
    }, [displayRoleNameDomCli]);

    useEffect(() => {
        checkText(addRoleNameDomCli, false, setAddRoleNameErrorDomCli);
    }, [addRoleNameDomCli]);
    // 


    const [showRoleSelectionModal, setShowRoleSelectionModal] = useState<boolean>(false);

    const handleShowRoleModal = () => {
        setShowRoleSelectionModal(true);
    }

    const handleCloseRoleModal = () => {
        setShowRoleSelectionModal(false);
    }

    return (
        <React.Fragment>
            <Toast ref={toast} />

            

            <div className="main_content layout_padding show_side_bar">
                <div className="main_head_area">
                    <h4 className="main_heading">Create Contact</h4>

                    <button className="back_btn p-ripple" onClick={goBack}>
                        <i className="bi bi-arrow-left me-2"></i>
                        Back
                        <Ripple />
                    </button>

 
                </div>

                <div className="page_content">
                    <div className="page_header_area">
                        <div className="contact_tabs">
                            {(isPermissionEmployee) && (
                                <div className="contact_tab_item">
                                    <button
                                        type="button"
                                        className="contact_tab_btn p-ripple"
                                        onClick={() => handleNavigateAddContact('employee')}
                                    >
                                        Employee
                                        <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                    </button>
                                </div>
                            )}

                            {(isPermissionProfessional) && (
                                <div className="contact_tab_item">
                                    <button
                                        type="button"
                                        className="contact_tab_btn p-ripple"
                                        onClick={() => handleNavigateAddContact('professional')}
                                    >
                                        Professional
                                        <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                    </button>
                                </div>
                            )}

                            {(isPermissionClient) && (
                                <div className="contact_tab_item">
                                    <button
                                        type="button"
                                        className="contact_tab_btn active p-ripple"
                                        onClick={() => handleNavigateAddContact('client')}
                                    >
                                        Client
                                        <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                    </button>
                                </div>
                            )}
                        </div>

                        <div className="select_option_area">
                            <Dropdown
                                value={employeeType}
                                id="employeeType"
                                onChange={handleEmployeeTypeChange}
                                options={employee_types}
                                optionLabel="employee_type"
                                placeholder="Employee type"
                                className="form_dropdown w-100"
                                disabled={contactId === 0 ? false : true}
                            />
                        </div>
                    </div>

                    <div className="page_label_area justify-content-center justify-content-sm-start">
                        <h6 className="text-capitalize text-center text-sm-start">{employeeType.employee_type}</h6>
                    </div>

                    {employeeType.employee_type === "Commercial client" ? (
                        <div className="page_body_area mt-3" style={{ minHeight }}>
                            <div className="row">
                                <div className="col-12">
                                    <div className="add_data_track_area">
                                        <div className={`add_data_track_point has_label ${commercialClientPage === 'Personal' || commercialClientPage === 'Project' || commercialClientPage === 'Role' ? 'active' : ''}`} data-label="Personal">
                                            <span>1</span>
                                        </div>

                                        <div className={`add_data_track_line ${commercialClientPage === 'Project' || commercialClientPage === 'Role' ? 'active' : ''}`}></div>

                                        <div className={`add_data_track_point has_label ${commercialClientPage === 'Project' || commercialClientPage === 'Role' ? 'active' : ''}`} data-label="Project">
                                            <span>2</span>
                                        </div>

                                        <div className={`add_data_track_line ${commercialClientPage === 'Role' ? 'active' : ''}`}></div>

                                        <div className={`add_data_track_point has_label ${commercialClientPage === 'Role' ? 'active' : ''}`} data-label="Role">
                                            <span>3</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {commercialClientPage === 'Personal' ? (
                                // Personal Form
                                <div className="row mt-5">
                                    <div className="col-12 col-xl-3 mx-auto page_divider">
                                        <div className="form_left_area">
                                            {/* Profile image */}
                                            <div className="form_img_upload_area">
                                                <div className="form_img_upload">
                                                    <input
                                                        type="file"
                                                        accept="image/*"
                                                        className="form_img_upload_input"
                                                        id="personalProfileImage"
                                                        onChange={handlePersonalProfileImageChange}
                                                    />
                                                    <label
                                                        htmlFor="personalProfileImage"
                                                        className="form_img_upload_label"
                                                        style={{ backgroundImage: personalProfileImage ? `url(${personalProfileImage})` : `` }}
                                                    >
                                                        {!personalProfileImage && (
                                                            <div className="upload_icon">
                                                                <i className="bi bi-camera-fill"></i>
                                                            </div>
                                                        )}
                                                    </label>
                                                    {personalProfileImage ? (
                                                        <button className="upload_clear_button mt-2" onClick={clearPersonalProfileImage}>Clear</button>
                                                    ) : (
                                                        <label htmlFor="personalProfileImage" className="add_image_label mt-2">Add image</label>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12 col-xl-9 mx-auto">
                                        <div className="form_right_area">
                                            <div className="page_data_form_area">
                                                <div className="row">

                                                    {/* First name */}
                                                    <div className="col-12 col-xl-6 col-sm-6">
                                                        <TextInput
                                                            id="firstName"
                                                            label="First name"
                                                            labelHtmlFor="firstName"
                                                            required={true}
                                                            value={firstName}
                                                            placeholder="First name"
                                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFirstName(e.target.value)}
                                                            error={errorFirstName}
                                                        />
                                                    </div>

                                                    {/* Last name */}
                                                    <div className="col-12 col-xl-6 col-sm-6">
                                                        <TextInput
                                                            id="lastName"
                                                            label="Last name"
                                                            labelHtmlFor="lastName"
                                                            required={true}
                                                            value={lastName}
                                                            placeholder="Last name"
                                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setLastName(e.target.value)}
                                                            error={errorLastName}
                                                        />
                                                    </div>

                                                    {/* Email */}
                                                    <div className="col-12 col-xl-6 col-sm-6">
                                                        <div className="page_form_group">
                                                            <label htmlFor="email" className="custom_form_label is_required">Email</label>

                                                            <div className="input_search_group">
                                                                <InputText
                                                                    id="email"
                                                                    value={email}
                                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setEmail(e.target.value)}
                                                                    className="custom_form_input"
                                                                    placeholder="Email"
                                                                    disabled
                                                                />

                                                                {!email ? (
                                                                    <button
                                                                        className="input_grp_btn primary pos_abs p-ripple"
                                                                        onClick={() => setShowSearchComClientEmailModal(true)}>
                                                                        <i className="bi bi-search"></i>
                                                                        <Ripple />
                                                                    </button>
                                                                ) : (
                                                                    <button
                                                                        className="input_grp_btn danger pos_abs p-ripple"
                                                                        onClick={() => setEmail('')}>
                                                                        <i className="bi bi-x-lg"></i>
                                                                        <Ripple />
                                                                    </button>
                                                                )}
                                                            </div>

                                                            {errorEmail &&
                                                                <small className="form_error_msg">{errorEmail}</small>
                                                            }
                                                        </div>
                                                    </div>

                                                    {/* Mobile */}
                                                    <div className="col-12 col-xl-6 col-sm-6">
                                                        <TextInput
                                                            id="mobile"
                                                            label="Mobile"
                                                            labelHtmlFor="mobile"
                                                            required={false}
                                                            value={mobile}
                                                            placeholder="Mobile"
                                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setMobile(e.target.value)}
                                                            error={errorMoblile}
                                                        />
                                                    </div>

                                                    {/* Landline */}
                                                    {/*<div className="col-12 col-xl-6 col-sm-6">
                                                        <TextInput
                                                            id="landline"
                                                            label="Landline"
                                                            labelHtmlFor="landline"
                                                            required={false}
                                                            value={landline}
                                                            placeholder="Landline"
                                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setLandline(e.target.value)}
                                                            error={errorLandline}
                                                        />
                                                    </div>*/}

                                                    {/* Address */}
                                                    <div className="col-12 col-xl-6 col-sm-6">
                                                        <TextInput
                                                            id="address"
                                                            label="Address"
                                                            labelHtmlFor="address"
                                                            required={true}
                                                            value={address}
                                                            placeholder="Address"
                                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setAddress(e.target.value)}
                                                            error={errorAddress}
                                                        />
                                                    </div>

                                                    {/* City */}
                                                    <div className="col-12 col-xl-6 col-sm-6">
                                                        <TextInput
                                                            id="city"
                                                            label="City"
                                                            labelHtmlFor="city"
                                                            required={true}
                                                            value={city}
                                                            placeholder="City"
                                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCity(e.target.value)}
                                                            error={errorCity}
                                                        />
                                                    </div>

                                                    {/* Post code */}
                                                    <div className="col-12 col-xl-6 col-sm-6">
                                                        <TextInput
                                                            id="postCode"
                                                            label="Post code"
                                                            labelHtmlFor="postCode"
                                                            required={true}
                                                            value={postCode}
                                                            placeholder="Post code"
                                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setPostCode(e.target.value)}
                                                            error={errorPostCode}
                                                        />
                                                    </div>

                                                    {/* Save */}
                                                    <div className="col-12">
                                                        <div className="form_btn_area justify-content-end">
                                                            <Button
                                                                label={`${loading ? 'Processing' : 'Save & Next'}`}
                                                                className="form_btn"
                                                                loading={loading}
                                                                onClick={handleSaveComClientPersonalDetails}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ) : commercialClientPage === 'Project' ? (
                                // Project Form
                                <div className="row mt-5">
                                    <div className="col-12 mx-auto">
                                        <div className="form_right_area">

                                            {projectList.length > 0 && (
                                                <div className="added_project_area">
                                                    {projectList.map((project) => (
                                                        <article className={`added_project ${showProjectDetailModal ? 'selected' : ''} p-ripple`} onClick={(e) => { handleSelectProject(e, project) }}>
                                                            <h6>{project.projectName}</h6>
                                                            <Ripple />
                                                        </article>
                                                    ))}
                                                </div>
                                            )}

                                            <div className={`page_data_form_area ${projectList.length > 0 && 'mt-0'}`}>
                                                <div className="row">
                                                    {/* Project name */}
                                                    <div className="col-12 col-xl-4 col-sm-6">
                                                        <TextInput
                                                            id="projectName"
                                                            label="Project name"
                                                            labelHtmlFor="projectName"
                                                            required={true}
                                                            value={projectName}
                                                            placeholder="Project name"
                                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setProjectName(e.target.value)}
                                                            error={errorProjectName}
                                                        />
                                                    </div>

                                                    {/* Address */}
                                                    <div className="col-12 col-xl-4 col-sm-6">
                                                        <TextInput
                                                            id="projectAddress"
                                                            label="Address"
                                                            labelHtmlFor="projectAddress"
                                                            required={true}
                                                            value={projectAddress}
                                                            placeholder="Address"
                                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setProjectAddress(e.target.value)}
                                                            error={errorProjectAddress}
                                                        />
                                                    </div>

                                                    {/* City */}
                                                    <div className="col-12 col-xl-4 col-sm-6">
                                                        <TextInput
                                                            id="projectCity"
                                                            label="City"
                                                            labelHtmlFor="projectCity"
                                                            required={true}
                                                            value={projectCity}
                                                            placeholder="City"
                                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setProjectCity(e.target.value)}
                                                            error={errorProjectCity}
                                                        />
                                                    </div>

                                                    {/* Post code */}
                                                    <div className="col-12 col-xl-4 col-sm-6">
                                                        <TextInput
                                                            id="projectPostCode"
                                                            label="Post code"
                                                            labelHtmlFor="projectPostCode"
                                                            required={true}
                                                            value={projectPostCode}
                                                            placeholder="Post code"
                                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setProjectPostCode(e.target.value)}
                                                            error={errorProjectPostCode}
                                                        />
                                                    </div>
                                                </div>

                                                <hr className="mt-0 mt-2 mt-sm-0 mb-4" />

                                                <div className="row">
                                                    {/* Company name */}
                                                    <div className="col-12 col-xl-4 col-sm-6">
                                                        <TextInput
                                                            id="companyName"
                                                            label="Company name"
                                                            labelHtmlFor="companyName"
                                                            required={false}
                                                            value={companyName}
                                                            placeholder="Company name"
                                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCompanyName(e.target.value)}
                                                            error={errorCompanyName}
                                                        />
                                                    </div>

                                                    {/* Reg No */}
                                                    <div className="col-12 col-xl-4 col-sm-6">
                                                        <TextInput
                                                            id="companyRegNo"
                                                            label="Reg No"
                                                            labelHtmlFor="companyRegNo"
                                                            required={false}
                                                            value={companyRegNo}
                                                            placeholder="Reg No"
                                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCompanyRegNo(e.target.value)}
                                                            error={errorCompanyRegNo}
                                                        />
                                                    </div>

                                                    {/* Company Email id */}
                                                    <div className="col-12 col-xl-4 col-sm-6">
                                                        <TextInput
                                                            id="companyEmail"
                                                            label="Company Email id"
                                                            labelHtmlFor="companyEmail"
                                                            required={false}
                                                            value={companyEmail}
                                                            placeholder="Company Email id"
                                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCompanyEmail(e.target.value)}
                                                            error={errorCompanyEmail}
                                                        />
                                                    </div>

                                                    {/* Mobile */}
                                                    <div className="col-12 col-xl-4 col-sm-6">
                                                        <TextInput
                                                            id="companyMobile"
                                                            label="Mobile"
                                                            labelHtmlFor="companyMobile"
                                                            required={false}
                                                            value={companyMobile}
                                                            placeholder="Mobile"
                                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCompanyMobile(e.target.value)}
                                                            error={errorCompanyMobile}
                                                        />
                                                    </div>

                                                    {/* Landline */}
                                                    {/*<div className="col-12 col-xl-4 col-sm-6">
                                                        <TextInput
                                                            id="companyLandline"
                                                            label="Landline"
                                                            labelHtmlFor="companyLandline"
                                                            required={false}
                                                            value={companyLandline}
                                                            placeholder="Landline"
                                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCompanyLandline(e.target.value)}
                                                            error={errorCompanyLandline}
                                                        />
                                                    </div>*/}

                                                    {/* Company address */}
                                                    <div className="col-12 col-xl-4 col-sm-6">
                                                        <TextInput
                                                            id="companyAddress"
                                                            label="Company address"
                                                            labelHtmlFor="companyAddress"
                                                            required={false}
                                                            value={companyAddress}
                                                            placeholder="Company address"
                                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCompanyAddress(e.target.value)}
                                                            error={errorCompanyAddress}
                                                        />
                                                    </div>

                                                    {/* City */}
                                                    <div className="col-12 col-xl-4 col-sm-6">
                                                        <TextInput
                                                            id="companyCity"
                                                            label="City"
                                                            labelHtmlFor="companyCity"
                                                            required={false}
                                                            value={companyCity}
                                                            placeholder="City"
                                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCompanyCity(e.target.value)}
                                                            error={errorCompanyCity}
                                                        />
                                                    </div>

                                                    {/* Post code */}
                                                    <div className="col-12 col-xl-4 col-sm-6">
                                                        <TextInput
                                                            id="companyPostCode"
                                                            label="Post code"
                                                            labelHtmlFor="companyPostCode"
                                                            required={false}
                                                            value={companyPostCode}
                                                            placeholder="Post code"
                                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCompanyPostCode(e.target.value)}
                                                            error={errorCompanyPostCode}
                                                        />
                                                    </div>

                                                    {/* Save */}
                                                    <div className="col-12">
                                                        <div className="form_btn_area justify-content-between flex-wrap flex-column-reverse flex-sm-row">
                                                            <button className={`add_data_btn p-ripple mt-3 mt-sm-0`}
                                                                onClick={handleAddProject}>
                                                                <i className={`bi bi-plus-circle`}></i>
                                                                Add another project
                                                                < Ripple />
                                                            </button>

                                                            <Button
                                                                label={`${loading ? 'Processing' : 'Save & Next'}`}
                                                                className="form_btn"
                                                                loading={loading}
                                                                onClick={handleSaveComClientProjectDetails}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ) : commercialClientPage === 'Role' ? (
                                //Role Form
                                <div className="row mt-5">
                                    <div className="col-12 col-xl-8 mx-auto h-100">
                                        <div className="page_data_form_area">
                                            <div className="form_right_area">
                                                <div className="row">
                                                    <div className="col-12 col-xl-6 col-sm-6">
                                                        <DataListModalInput
                                                            key={`role`}
                                                            inputId="role"
                                                            label="Role"
                                                            value={selectedRole}
                                                            displayKey="role_name"
                                                            onAdd={handleShowRoleModal}
                                                            required={true}
                                                            placeHolder="Click to select the role"
                                                            error={selectedRoleErrorDomCli}
                                                        />
                                                    </div>

                                                    {/* Display role name */}
                                                    <div className="col-12 col-xl-6 col-sm-6">
                                                        <TextInput
                                                            id="displayRoleName"
                                                            label="Display role name"
                                                            labelHtmlFor="displayRoleName"
                                                            required={true}
                                                            value={displayRoleName}
                                                            placeholder="Display role name"
                                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setDisplayRoleName(e.target.value)}
                                                            error={displayRoleNameError}
                                                        />
                                                    </div>

                                                    <div className="col-12">
                                                        <div className="form_btn_area justify-content-center">
                                                            {displayRoleCommonError !== '' &&
                                                                <small className="form_error_msg">{displayRoleCommonError}</small>
                                                            }
                                                        </div>
                                                    </div>

                                                    <div className="col-12">
                                                        <div className="form_btn_area justify-content-end">
                                                            <Button
                                                                label={`${loading ? 'Processing' : 'Save'}`}
                                                                className="form_btn"
                                                                loading={loading}
                                                                onClick={handleSaveComClientRoleDetails}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ) : null
                            }
                        </div>
                    ) : (employeeType?.employee_type === "Domestic client") ? (
                        <div className="page_body_area mt-3" style={{ minHeight }}>
                            <div className="row">
                                <div className="col-12">
                                    <div className="add_data_track_area">
                                        <div className={`add_data_track_point has_label ${domesticClientPage === 'Personal' || domesticClientPage === 'Project' || domesticClientPage === 'Role' ? 'active' : ''}`} data-label="Personal">
                                            <span>1</span>
                                        </div>

                                        <div className={`add_data_track_line ${domesticClientPage === 'Project' || domesticClientPage === 'Role' ? 'active' : ''}`}></div>

                                        <div className={`add_data_track_point has_label ${domesticClientPage === 'Project' || domesticClientPage === 'Role' ? 'active' : ''}`} data-label="Project">
                                            <span>2</span>
                                        </div>

                                        <div className={`add_data_track_line ${domesticClientPage === 'Role' ? 'active' : ''}`}></div>

                                        <div className={`add_data_track_point has_label ${domesticClientPage === 'Role' ? 'active' : ''}`} data-label="Role">
                                            <span>3</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {domesticClientPage === 'Personal' ? (
                                // Personal Form
                                <div className="row mt-5">
                                    <div className="col-12 col-xl-3 mx-auto page_divider">
                                        <div className="form_left_area">
                                            {/* Profile image */}
                                            <div className="form_img_upload_area">
                                                <div className="form_img_upload">
                                                    <input
                                                        type="file"
                                                        accept="image/*"
                                                        className="form_img_upload_input"
                                                        id="personalProfileImage"
                                                        onChange={handlePersonalProfileImageChange}
                                                    />
                                                    <label
                                                        htmlFor="personalProfileImage"
                                                        className="form_img_upload_label"
                                                        style={{ backgroundImage: personalProfileImage ? `url(${personalProfileImage})` : `` }}
                                                    >
                                                        {!personalProfileImage && (
                                                            <div className="upload_icon">
                                                                <i className="bi bi-camera-fill"></i>
                                                            </div>
                                                        )}
                                                    </label>
                                                    {personalProfileImage ? (
                                                        <button className="upload_clear_button mt-2" onClick={clearPersonalProfileImage}>Clear</button>
                                                    ) : (
                                                        <label htmlFor="personalProfileImage" className="add_image_label mt-2">Add image</label>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12 col-xl-9 mx-auto">
                                        <div className="form_right_area">
                                            <div className="page_data_form_area">
                                                <div className="row">
                                                    {/* First name */}
                                                    <div className="col-12 col-xl-6 col-sm-6">
                                                        <TextInput
                                                            id="firstName"
                                                            label="First name"
                                                            labelHtmlFor="firstName"
                                                            required={true}
                                                            value={firstNameDomCli}
                                                            placeholder="First name"
                                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFirstNameDomCli(e.target.value)}
                                                            error={firstNameDomCliError}
                                                        />
                                                    </div>

                                                    {/* Last name */}
                                                    <div className="col-12 col-xl-6 col-sm-6">
                                                        <TextInput
                                                            id="lastName"
                                                            label="Last name"
                                                            labelHtmlFor="lastName"
                                                            required={true}
                                                            value={lastNameDomCli}
                                                            placeholder="Last name"
                                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setLastNameDomCli(e.target.value)}
                                                            error={lastNameDomCliError}
                                                        />
                                                    </div>

                                                    {/* Email */}
                                                    <div className="col-12 col-xl-6 col-sm-6">
                                                        <div className="page_form_group">
                                                            <label htmlFor="emailDomCli" className="custom_form_label is_required">Email</label>

                                                            <div className="input_search_group">
                                                                <InputText
                                                                    id="emailDomCli"
                                                                    value={emailDomCli}
                                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setEmailDomCli(e.target.value)}
                                                                    className="custom_form_input"
                                                                    placeholder="Email"
                                                                    disabled
                                                                />

                                                                {!emailDomCli ? (
                                                                    <button
                                                                        className="input_grp_btn primary pos_abs p-ripple"
                                                                        onClick={() => setShowSearchDomClientEmailModal(true)}>
                                                                        <i className="bi bi-search"></i>
                                                                        <Ripple />
                                                                    </button>
                                                                ) : (
                                                                    <button
                                                                        className="input_grp_btn danger pos_abs p-ripple"
                                                                        onClick={() => setEmailDomCli('')}>
                                                                        <i className="bi bi-x-lg"></i>
                                                                        <Ripple />
                                                                    </button>
                                                                )}
                                                            </div>

                                                            {emailDomCliError &&
                                                                <small className="form_error_msg">{emailDomCliError}</small>
                                                            }
                                                        </div>
                                                    </div>

                                                    {/* Mobile */}
                                                    <div className="col-12 col-xl-6 col-sm-6">
                                                        <TextInput
                                                            id="mobile"
                                                            label="Mobile"
                                                            labelHtmlFor="mobile"
                                                            required={false}
                                                            value={mobileDomCli}
                                                            placeholder="Mobile"
                                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setMobileDomCli(e.target.value)}
                                                            error={mobileDomCliError}
                                                        />
                                                    </div>

                                                    {/* Landline */}
                                                    {/*<div className="col-12 col-xl-6 col-sm-6">
                                                        <TextInput
                                                            id="landline"
                                                            label="Landline"
                                                            labelHtmlFor="landline"
                                                            required={false}
                                                            value={landline}
                                                            placeholder="Landline"
                                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setLandline(e.target.value)}
                                                            error=""
                                                        />
                                                    </div>*/}

                                                    {/* Address */}
                                                    <div className="col-12 col-xl-6 col-sm-6">
                                                        <TextInput
                                                            id="address"
                                                            label="Address"
                                                            labelHtmlFor="address"
                                                            required={true}
                                                            value={addressDomCli}
                                                            placeholder="Address"
                                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setAddressDomCli(e.target.value)}
                                                            error={addressDomCliError}
                                                        />
                                                    </div>

                                                    {/* City */}
                                                    <div className="col-12 col-xl-6 col-sm-6">
                                                        <TextInput
                                                            id="city"
                                                            label="City"
                                                            labelHtmlFor="city"
                                                            required={true}
                                                            value={cityDomCli}
                                                            placeholder="City"
                                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCityDomCli(e.target.value)}
                                                            error={cityDomCliError}
                                                        />
                                                    </div>

                                                    {/* Post code */}
                                                    <div className="col-12 col-xl-6 col-sm-6">
                                                        <TextInput
                                                            id="postCode"
                                                            label="Post code"
                                                            labelHtmlFor="postCode"
                                                            required={true}
                                                            value={postCodeDomCli}
                                                            placeholder="Post code"
                                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setPostCodeDomCli(e.target.value)}
                                                            error={postCodeDomCliError}
                                                        />
                                                    </div>

                                                    {/* Save */}
                                                    <div className="col-12">
                                                        <div className="form_btn_area justify-content-end">
                                                            <Button
                                                                label={`${loading ? 'Processing' : 'Save & Next'}`}
                                                                className="form_btn"
                                                                loading={loading}
                                                                onClick={handleSaveDomClientPersonalDetails}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ) : domesticClientPage === 'Project' ? (
                                // Project Form
                                <div className="row mt-5">
                                    <div className="col-12 col-xxl-8 col-xl-9 mx-auto">
                                        <div className="form_right_area">
                                            <div className="page_data_form_area">
                                                <div className="row">
                                                    <div className="col-12">
                                                        <div className="page_form_group">
                                                            <div className="page_form_check">
                                                                <Checkbox inputId="checkedProjectState" onChange={e => handleDomCliProjectAddressSameCheckBoxOnChange(e.checked ?? false)} checked={checkedProjectState}></Checkbox>
                                                                <label htmlFor="checkedProjectState">The project and contact address is same</label>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* Address */}
                                                    <div className="col-12 col-xl-6 col-sm-6">
                                                        <TextInput
                                                            id="projectAddress"
                                                            label="Address"
                                                            labelHtmlFor="projectAddress"
                                                            required={true}
                                                            value={projectAddressDomCli}
                                                            placeholder="Address"
                                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setProjectAddressDomCli(e.target.value)}
                                                            error={projectAddressDomCliError}
                                                        />
                                                    </div>

                                                    {/* City */}
                                                    <div className="col-12 col-xl-6 col-sm-6">
                                                        <TextInput
                                                            id="projectCity"
                                                            label="City"
                                                            labelHtmlFor="projectCity"
                                                            required={true}
                                                            value={projectCityDomCli}
                                                            placeholder="City"
                                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setProjectCityDomCli(e.target.value)}
                                                            error={projectCityDomCliError}
                                                        />
                                                    </div>

                                                    {/* Post code */}
                                                    <div className="col-12 col-xl-6 col-sm-6">
                                                        <TextInput
                                                            id="projectPostCode"
                                                            label="Post code"
                                                            labelHtmlFor="projectPostCode"
                                                            required={true}
                                                            value={projectPostCodeDomCli}
                                                            placeholder="Post code"
                                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setProjectPostCodeDomCli(e.target.value)}
                                                            error={projectPostCodeDomCliError}
                                                        />
                                                    </div>

                                                    {/* Save */}
                                                    <div className="col-12">
                                                        <div className="form_btn_area justify-content-end">
                                                            <Button
                                                                label={`${loading ? 'Processing' : 'Save & Next'}`}
                                                                className="form_btn"
                                                                loading={loading}
                                                                onClick={handleSaveDomClientProjectDetails}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ) : domesticClientPage === 'Role' ? (
                                //Role Form
                                <div className="row mt-5">
                                    <div className="col-12 col-xl-8 mx-auto h-100">
                                        <div className="page_data_form_area">
                                            <div className="form_right_area">
                                                <div className="row">
                                                    {/* Role name */}
                                                    <div className="col-12 col-xl-6 col-sm-6">
                                                        <DataListModalInput
                                                            key={`role`}
                                                            inputId="role"
                                                            label="Role"
                                                            value={selectedRole}
                                                            displayKey="role_name"
                                                            onAdd={handleShowRoleModal}
                                                            required={true}
                                                            placeHolder="Click to select the role"
                                                            error={selectedRoleErrorDomCli}
                                                        />
                                                    </div>

                                                    {/* Display role name */}
                                                    <div className="col-12 col-xl-6 col-sm-6">
                                                        <TextInput
                                                            id="displayRoleName"
                                                            label="Display role name"
                                                            labelHtmlFor="displayRoleName"
                                                            required={true}
                                                            value={displayRoleNameDomCli}
                                                            placeholder="Display role name"
                                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setDisplayRoleNameDomCli(e.target.value)}
                                                            error={displayRoleNameErrorDomCli}
                                                        />
                                                    </div>

                                                    <div className="col-12">
                                                        <div className="form_btn_area justify-content-center">
                                                            {displayRoleCommonErrorDomCli !== '' &&
                                                                <small className="form_error_msg">{displayRoleCommonErrorDomCli}</small>
                                                            }
                                                        </div>
                                                    </div>

                                                    {/* Save */}
                                                    <div className="col-12">
                                                        <div className="form_btn_area justify-content-end">
                                                            <Button
                                                                label={`${loading ? 'Processing' : 'Save'}`}
                                                                className="form_btn"
                                                                loading={loading}
                                                                onClick={handleSaveDomClientRoleDetails}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ) : null
                            }
                        </div>
                    ) : null
                    }
                </div>
            </div>


            <RoleSelectionModal
                isOpen={showRoleSelectionModal}
                onClose={handleCloseRoleModal}
                canEdit={true}
                onSelected={(role: Role) => {
                    setSelectedRole(role);
                    setDisplayRoleNameDomCli(role?.display_role_name ?? '');
                    setDisplayRoleName(role?.display_role_name ?? '')
                }}
            />

            {/* Show success message */}
            <div className={`message_backdrop ${showAlert ? 'show' : ''}`} onClick={handleCloseAlert}>
                <div className={`message_box ${showAlert ? 'show' : ''}`} onClick={e => e.stopPropagation()}>
                    <div className="message_box_content">
                        <i className="bi bi-check-circle-fill message_box_icon"></i>
                        <h6 className="message_box_message">
                            {successMessage}
                        </h6>
                    </div>
                </div>
            </div>
            {/*  */}

            <Dialog
                visible={showProjectDetailModal}
                header={projectDetailModalHeader}
                footer={projectDetailModalFooter}
                headerClassName="custom_modal_header"
                className="custom_modal_dialog modal_dialog_lg"
                onHide={handleCloseProjectDetailModal}
                dismissableMask
            >
                <div className="custom_modal_body">
                    <div className="p-1 pt-3 pb-0 p-sm-4 pt-sm-3 pb-sm-0 w-100">
                        <div className="row">
                            {/* First name */}
                            <ModelContent title={'First name'} data={selectProject?.projectName || '---'} />

                            {/* Address */}
                            <ModelContent title={'Address'} data={selectProject?.projectAddress || '---'} />

                            {/* City */}
                            <ModelContent title={'City'} data={selectProject?.projectCity || '---'} />

                            {/* Post code */}
                            <ModelContent title={'Post code'} data={selectProject?.projectPostCode || '---'} />
                        </div>

                        <hr className="mt-0 mt-2 mt-sm-0 mb-4" />

                        <div className="row">
                            {/* Company name */}
                            <ModelContent title={'Company name'} data={selectProject?.companyName || '---'} />

                            {/* Reg No */}
                            <ModelContent title={'Reg No'} data={selectProject?.companyRegNo || '---'} />

                            {/* Company Email id */}
                            <ModelContent title={'Company Email id'} data={selectProject?.email || '---'} />

                            {/* Mobile */}
                            <ModelContent title={'Mobile'} data={selectProject?.mobile || '---'} />

                            {/* Company address */}
                            <ModelContent title={'Company address'} data={selectProject?.address || '---'} />

                            {/* City */}
                            <ModelContent title={'City'} data={selectProject?.city || '---'} />

                            {/* Post code */}
                            <ModelContent title={'Post code'} data={selectProject?.postCode || '---'} />
                        </div>
                    </div>
                </div>
            </Dialog>


            <EmailSearchDialog
                visible={showSearchComClientEmailModal}
                contactSubtype="Commercial Client"
                onHide={() => setShowSearchComClientEmailModal(false)}
                onEmailConfirm={(email) => onEmailConfirmComClient(email)}
            />

            <EmailSearchDialog
                visible={showSearchDomClientEmailModal}
                contactSubtype="Domestic Client"
                onHide={() => setShowSearchDomClientEmailModal(false)}
                onEmailConfirm={(email) => onEmailConfirmDomClient(email)}
            />
        </React.Fragment>
    )

}

export default AddClientContact;
